import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useInfiniteCourseReviews } from 'querys/reviews'
import { Typography } from 'common/typography'
import useIntersectionObserver from 'hooks/use-intersection-observer'
import { TransparentButton } from 'common/button'
import { FaChevronDown } from 'react-icons/fa'
import Review from './review-redesing'

const ReviewListStyled = styled.section`
  grid-area: reviews;
  @media(min-width: 1024px) {
    padding: 110px 0;
  }
`

function ReviewList({ setActive, reviewCount, setReviewCount }) {
  const { data: { pages }, fetchNextPage, hasNextPage } = useInfiniteCourseReviews()

  const { ref: reviewsRef } = useIntersectionObserver({
    onIntersect: () => setActive('valoraciones'),
    rootMargin: '0px 0px -100px 0px',
  })

  const handleMoreReviews = () => {
    fetchNextPage()
    setTimeout(() => {
      setReviewCount(reviewCount + 1)
    }, 600)
  }

  if (!pages || !pages?.length || (pages && !pages[0].count)) {
    return (
      <ReviewListStyled id="valoraciones" ref={reviewsRef}>
        <Typography small="headline6" large="headline5" color="var(--baseNeutral)">
          Valoraciones
        </Typography>
        <Review
          userAvatar="/images/courses/avatar.svg"
          firstName="Tú"
          lastName=""
          comment="Al llegar al 30% del curso podrás añadir una reseña del curso. "
          stars={5}
        />
      </ReviewListStyled>
    )
  }

  return (
    <ReviewListStyled aria-labelledby="student-reviews" id="valoraciones" ref={reviewsRef}>
      <Typography as="h2" id="student-reviews" small="headline6" large="headline5" color="var(--baseNeutral)">
        Valoraciones
      </Typography>
      {pages.map(
        ({ results }) => results.map(({
          author: {
            email, photo, first_name, last_name,
          },
          stars,
          comment,
        }, idx) => (
          <Review
            idx={idx}
            key={email}
            userAvatar={photo}
            firstName={first_name}
            lastName={last_name}
            stars={parseInt(stars, 10)}
            comment={comment}
          />
        )),
      )}
      {hasNextPage ? (
        <TransparentButton color="var(--secondary)" onClick={() => handleMoreReviews()}>
          Ver mas reseñas
          <FaChevronDown size={14} color="inherit" />
        </TransparentButton>
      ) : (
        <TransparentButton as="a" href="#comprar" color="var(--secondary)">
          Ver opciones de pago
        </TransparentButton>
      )}
    </ReviewListStyled>
  )
}

ReviewList.propTypes = {
  setActive: PropTypes.func.isRequired,
  reviewCount: PropTypes.number.isRequired,
  setReviewCount: PropTypes.func.isRequired,
}

export default ReviewList
